module.exports = __webpack_public_path__ + "static/media/power-off.a07cb80b.svg";